import { RichText, Text } from '@sitecore-jss/sitecore-jss-nextjs';
import ExpandableContent from 'components/Generic/ExpandableContent';
import { ReactNode, useState } from 'react';

type AccordionNewProps = {
  title: object;
  description: object;
  isFirst: boolean;
  children?: ReactNode;
};

const AccordionNew = ({ title, children, description, isFirst = false }: AccordionNewProps) => {
  const [show, setShow] = useState(false);

  return (
    <div className={`accordion accordion__new border-bottom ${isFirst ? 'border-top' : ''}`}>
      <button
        className="btn-naked d-flex justify-content-between align-items-center w-100 py-3 gap-1"
        aria-expanded={show ? 'true' : 'false'}
        onClick={() => setShow(!show)}
      >
        <Text tag="h3" field={title} />
        <svg
          className="accordion__icon"
          aria-hidden="true"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 7.40068V5L12.8565 16.0448L12.0086 16.9101L11.1435 16.0448L0.0171306 5.01697L0 7.38371L12 19.2853L24 7.40068Z"
            fill="currentColor"
          />
        </svg>
      </button>
      <ExpandableContent show={show}>
        <div className="accordion__panel">
          <div className="accordion__panel__inner">
            <RichText field={description} className="body-default" />
            {children}
          </div>
        </div>
      </ExpandableContent>
    </div>
  );
};

export default AccordionNew;
